var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00005 19.4187C7.46533 19.4187 7.01463 19.2316 6.64797 18.8573C6.2813 18.483 6.09797 18.0208 6.09797 17.4708H9.90213C9.90213 18.0208 9.7188 18.483 9.35213 18.8573C8.98547 19.2316 8.53477 19.4187 8.00005 19.4187ZM4.24172 16.0041V14.5604H11.7584V16.0041H4.24172ZM4.3563 13.1396C3.33269 12.4673 2.51533 11.6271 1.90422 10.6187C1.2931 9.6104 0.987549 8.47221 0.987549 7.20415C0.987549 5.30971 1.67887 3.66734 3.06151 2.27707C4.44415 0.886789 6.09033 0.19165 8.00005 0.19165C9.89449 0.19165 11.5369 0.886789 12.9271 2.27707C14.3174 3.66734 15.0125 5.30971 15.0125 7.20415C15.0125 8.47221 14.7108 9.6104 14.1073 10.6187C13.5039 11.6271 12.6827 12.4673 11.6438 13.1396H4.3563ZM4.92922 11.5812H11.0938C11.8271 11.0923 12.4039 10.4621 12.824 9.69061C13.2441 8.91908 13.4542 8.09026 13.4542 7.20415C13.4542 5.70693 12.9195 4.42359 11.85 3.35415C10.7806 2.28471 9.49727 1.74998 8.00005 1.74998C6.50283 1.74998 5.21949 2.28471 4.15005 3.35415C3.0806 4.42359 2.54588 5.70693 2.54588 7.20415C2.54588 8.09026 2.75977 8.91908 3.18755 9.69061C3.61533 10.4621 4.19588 11.0923 4.92922 11.5812Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.e6eb1fc1.svg";
export { ForwardRef as ReactComponent };